import { render, staticRenderFns } from "./orderInformation.vue?vue&type=template&id=479a68e8&scoped=true&"
import script from "./orderInformation.vue?vue&type=script&lang=js&"
export * from "./orderInformation.vue?vue&type=script&lang=js&"
import style0 from "./orderInformation.vue?vue&type=style&index=0&id=479a68e8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a68e8",
  null
  
)

export default component.exports